import classNames from "classnames";
import { ContactAvatar } from "components/Atoms/Avatar";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import React from "react";

interface IContactBirthdayItem {
  birthday: server.dto.ContactBirthday
  isLast: boolean
}

const ContactBirthdayRowCard = ({ birthday, isLast }: IContactBirthdayItem) => {
  const cardClasses = classNames("radius hoverable", "birthday-contact-card", {
    "aged-recently": birthday.agedRecently,
    "birthday-contact-last-card": isLast
  });

  return <ContactSidePanel
    contactId={birthday.contactId}
    trigger={
      <div className={cardClasses}>
        {birthday.isValidated
          ? <ContactAvatar name={birthday.fullName} profileImageUrl={birthday.profileImageUrl} gender={birthday.gender} />
          : <span title={birthday.fullName}>
            <PhosphorWarning iconSize="large" />
          </span>}
        <div className="grow1">
          <div>{birthday.fullName}</div>
          <div className="aged-message text-sublabel">{birthday.agedMessage}</div>
        </div>
        <div className="birth-text s1_small">
          {birthday.birthText}
        </div>
      </div>
    }
  />;
};

export default ContactBirthdayRowCard;
